import { render, staticRenderFns } from "./ReturnDetails.vue?vue&type=template&id=f7db97f4"
import script from "./ReturnDetails.vue?vue&type=script&lang=js"
export * from "./ReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./ReturnDetails.vue?vue&type=style&index=0&id=f7db97f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports